import React from "react";
import { Switch, Route } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import About from "../pages/about";
import Contact from "../pages/contact";
import Home from "../pages/home";
import Portfolio from "../pages/portfolio";
import Resume from "../pages/resume";

const routes = () => {
  return (
    <div>
      <Sidebar />
      <Switch>
        <Route path="/about" component={About} />
        <Route path="/resume" component={Resume} />
        <Route path="/portfolio" component={Portfolio} />
        <Route path="/contact" component={Contact} />
        <Route path="/" component={Home} />
      </Switch>
    </div>
  );
};

export default routes;
